import Header from "@/components/layout/Header";
import PageHeaderTitle from "@/components/layout/PageHeaderText";
import PageLayout from "@/components/layout/PageLayout";
import ExplorePoolsListener from "@/features/explore/listeners/ExplorePoolsListener";
import { createFileRoute } from "@tanstack/react-router";
import SpotPositionsMarqueeHeader from "../-components/SpotPositionsMarqueeHeader";
import ExploreTable from "./-components/ExploreTable";
import ExploreTableFilters from "./-components/ExploreTableFilters";
import { ExploreFiltersProvider } from "./-providers/explore-filters-provider";

export const Route = createFileRoute("/_main/explore/")({
  head: () => ({
    meta: [{ title: "Reactor | Explore" }],
  }),
  component: ExplorePage,
});

function ExplorePage() {
  const pageHeader = (
    <>
      <PageHeaderTitle title="Explore" />
      <SpotPositionsMarqueeHeader />
      <Header />
    </>
  );

  return (
    <PageLayout header={pageHeader}>
      <ExploreFiltersProvider>
        <ExplorePoolsListener>
          <div className="flex h-full max-h-full w-full flex-col gap-1.5">
            <ExploreTableFilters />

            <ExploreTable />
          </div>
        </ExplorePoolsListener>
      </ExploreFiltersProvider>
    </PageLayout>
  );
}
